import * as React from 'react';
import { SearchForm } from '@app/src/views/Agency/listAgencies';

export const ListAgencies: React.FC = () => <SearchForm />;
